/**
 * Initialize registrant input on selects
 */
const initialize = function() {
    $(document).on('change', '.form-group.select select', function() {
        let $form            = $(this).closest('form');
        let regex            = /[\s^]campaign-field-(\d+)[\s$]/;
        let formGroupClasses = $(this).closest('.form-group').attr('class');

        let regexMatch = regex.exec(formGroupClasses);
        if (!regexMatch) { // We're not dealing with a campaign field
            return;
        }

        let $targetRegistrantInputField = $form.find(`.form-group.registrant-input-${regexMatch[1]}`);
        if ($targetRegistrantInputField.length > 0) {
            let currentValue = $(this).val();
            if (currentValue === 'registrant-input') {
                // Show and enable the registrant input field
                $targetRegistrantInputField.removeClass('d-none');
                $targetRegistrantInputField.find('input').prop('disabled', false);
            } else {
                // Hide and disable the registrant input field
                $targetRegistrantInputField.addClass('d-none');
                $targetRegistrantInputField.find('input').prop('disabled', true);
            }
        }
    });
};

/**
 * Initialize a container by triggering change on the inputs
 * {jQuery} $container
 */
const initializeContainer = function($container) {
    $(document).ready(function() {
        $('.form-group.select select', $container).trigger('change');
    });
};

// Export defaults
export default {
    initialize:          initialize,
    initializeContainer: initializeContainer,
}



// WEBPACK FOOTER //
// ./build/script/src/components/registrant_input.js